import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledOBannerFeatureEditorial = styled.section`
  background-color: #1c1c1c;
  color: ${baseVariables.color.base10};
  padding: ${toRem(32)} ${toRem(16)};

  @media ${baseVariables.mediaQuery.md}, @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
    padding: ${toRem(40)} ${toRem(16)};
  }

  .obanner-feature-editorial__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${toRem(24)};
    max-width: ${toRem(1140)};
    margin: 0 auto;
  }

  .obanner-feature-editorial__media {
    width: 100%;
    aspect-ratio: 1140 / 641.25;
    border-radius: 0;
  }

  .obanner-feature-editorial__media [data-component-name='m-web-ui-kit-MMediaImage'],
  .obanner-feature-editorial__media [data-component-name='a-web-ui-kit-AImage'],
  .obanner-feature-editorial__media img {
    border-radius: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .obanner-feature-editorial__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    gap: ${toRem(24)};
  }

  .obanner-feature-editorial__copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: ${toRem(16)};
  }

  .obanner-feature-editorial__copy [data-component-name='m-web-ui-kit-MTextBlockStandard'] {
    gap: ${toRem(16)};
  }

  .obanner-feature-editorial__copy [data-component-name='a-web-ui-kit-AEyebrow'],
  .obanner-feature-editorial__copy [data-component-name='a-web-ui-kit-AHeader'],
  .obanner-feature-editorial__copy [data-component-name='a-web-ui-kit-ASubheader'],
  .obanner-feature-editorial__copy [data-component-name='a-web-ui-kit-ABody'] {
    color: var(--Color-Set-brand-fg-color, #fff);
  }

  .obanner-feature-editorial__copy [data-component-name='a-web-ui-kit-AEyebrow'] {
    letter-spacing: ${toRem(1.2)};
    color: var(--Color-Set-brand-alt-color, #c4c4c4);
  }

  .obanner-feature-editorial__subheader,
  .obanner-feature-editorial__body {
    margin: 0;
    max-width: ${toRem(1140)};
  }

  .obanner-feature-editorial__cta {
    border: 1px solid var(--Color-Set-button-secondary-border-color, #fff);
    border-radius: 0;
  }

  .obanner-feature-editorial__cta .btn-label {
    color: var(--Color-Set-button-secondary-fg-color, #fff);
  }

  .obanner-feature-editorial__cta [data-component-name='a-web-ui-kit-AIcon'] {
    display: none;
  }

  @media ${baseVariables.mediaQuery.md} {
    padding: ${toRem(64)} ${toRem(48)};
  }

  @media ${baseVariables.mediaQuery.xl} {
    padding: ${toRem(64)} ${toRem(150)};
  }
`;
